import { useEffect } from 'react';

export type ShortcutMap = Record<string, (() => void) | undefined>;

function typing(target: EventTarget | null): boolean {
  const t = target as HTMLElement | null;
  return !!t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable);
}

/** Bare-key shortcuts keyed by `event.key` (letters lower-case, or 'Escape'/'Enter'); ignored with modifiers, while typing (except Escape), or when disabled. */
export function useShortcuts(map: ShortcutMap, enabled = true): void {
  useEffect(() => {
    if (!enabled) return;
    const onKey = (e: KeyboardEvent): void => {
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      if (typing(e.target) && e.key !== 'Escape') return;
      const key = e.key.length === 1 ? e.key.toLowerCase() : e.key;
      const fn = map[key];
      if (!fn) return;
      e.preventDefault();
      fn();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [map, enabled]);
}
